// Share links found in template:
// https://github.com/99designs/contests/blob/master/src/NinetyNine/ContestBundle/Resources/views/Header/partials/contest-actions-menu.html.twig#L89

import trackEvent from '@99designs/common/utils/platform/trackEvent';

function socialShareTracking() {
    const trackShareClick = (socialPlatform) => {
        trackEvent('Clicked Social Share Button', {
            share_via: socialPlatform,
            share_subject_type: 'contest',
            location: 'Contest Header',
        });
    };

    const facebookShare = document.querySelector("[data-share='Facebook']");
    const twitterShare = document.querySelector("[data-share='Twitter']");
    const pinterestShare = document.querySelector("[data-share='pinterest']");

    if (facebookShare) {
        facebookShare.addEventListener('click', function (e) {
            trackShareClick('facebook');
        });
    }
    if (twitterShare) {
        twitterShare.addEventListener('click', function (e) {
            trackShareClick('twitter');
        });
    }
    if (pinterestShare) {
        pinterestShare.addEventListener('click', function (e) {
            trackShareClick('pinterest');
        });
    }
}

export default socialShareTracking;



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/social-share-tracking.js